module.exports = [{
      plugin: require('../../../node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[],"offsetY":0,"className":"anchor"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Guitar Book","short_name":"Guitar Book","description":"Track and play best guitar songs for camping","start_url":"/","background_color":"#ede9fb","theme_color":"#3f20ba","display":"standalone","icon":"/opt/build/repo/packages/gatsby-theme-guitar-book/src/assets/images/logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"5a90b6b8feabc25bfce6f861c7a9ebd5"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../gatsby-theme-guitar-book/gatsby-browser.js'),
      options: {"plugins":[],"contentfulAPIKey":"hbJYz3IerHX0sL6WagJjIKC6D5-5ik04oX5gT066Ej8","contentfulSpaceId":"zbrk25eluz73"},
    }]
